import { render, staticRenderFns } from "./healthCareNextDetail.vue?vue&type=template&id=f843ece0&scoped=true&"
import script from "./healthCareNextDetail.vue?vue&type=script&lang=js&"
export * from "./healthCareNextDetail.vue?vue&type=script&lang=js&"
import style0 from "./healthCareNextDetail.vue?vue&type=style&index=0&id=f843ece0&lang=scss&scoped=true&"
import style1 from "./healthCareNextDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f843ece0",
  null
  
)

export default component.exports